<div class="main-container">
  <div class="main-page">
    <div class="prospect-detail">
      <div class="white-card">
        <div class="header-title-row" style="padding-bottom: 16px">
          <div class="header-left">
            <img
              src="assets/svg/goals-icon.svg"
              alt="oportunidades"
              class="center-svg"
            />
            <h1 class="text-semibold color-org t-24">Metas</h1>
          </div>

          <div class="header-actions">
            <div class="text-center event-item">
              <button class="btn btn-round-outline" (click)="refrescarMetas()">
                <img class="center-svg" src="assets/svg/reload-icon-org.svg" />
              </button>
            </div>

            <button class="action-btn primary" (click)="goToGoalsGraphic()">
              <img src="assets/svg/stast-white.svg" alt="Ver gráficos" width="16" height="16" />
              Ver gráficos
            </button>
            <button *ngIf="permissionService.hasPermission('Metas','Crear')" class="action-btn primary" (click)="openMdlCreateGoal()">
              <img
                src="assets/svg/plus-icon.svg"
                alt="Añadir nuevo"
                width="16"
                height="16"
              />
              Crear nuevas metas
            </button>
          </div>

          <div class="open-tab-title" style="padding-top: 3px">
            <div style="padding-top: 3px">
              <div class="d-grid general-title">
                <div><h2 class="text-semibold">Vista Resumen</h2></div>
                <div class="d-grid filter-opportunities">
                  <div class="d-grid filter-opp">
                    <div>Fecha de cierre</div>
                    <select [(ngModel)]="filtroFecha" (change)="filtrarMetas()">
                      <option value="nuevo">Más nuevo</option>
                      <option value="antiguo">Más antiguo</option>
                    </select>
                  </div>
                  <div class="d-grid filter-opp">
                    <div>Propietario</div>
                    <select [(ngModel)]="filtroPropietario" (change)="filtrarMetas()">
                      <option value="">Todos los ejecutivos</option>
                      <option *ngFor="let usuario of usuarios" [value]="usuario.usuario_id">
                        {{ usuario.nombre }} {{ usuario.apellido }}
                      </option>
                    </select>
                  </div>
                  <div class="d-grid filter-opp">
                    <div>Cambios desde</div>
                    <select name="" id="">
                      <option value="">Inicio</option>
                    </select>
                  </div>
                  <div class="text-center event-item">
                    <button
                      class="btn btn-round-outline btn-mark"
                      (click)="checkMarkedGoals()"
                    >
                      <img
                        class="center-svg"
                        src="assets/svg/bookmark-icon.svg"
                      />
                    </button>
                  </div>
                  <div class="text-center event-item">
                    <button class="btn btn-round-outline" (click)="openFilterModal()">
                      <img
                        class="center-svg"
                        src="assets/svg/filterpng-icon.svg"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <div class="d-grid progress-status-row mt-3">
                <div
                  class="status-card-4"
                  (mouseenter)="hoverCard = 'metas'"
                  (mouseleave)="hoverCard = ''"
                >
                  <div
                    class="content-card-4"
                    [ngClass]="{'hovered': hoverCard === 'metas'}"
                  >
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-1.svg"
                        class="card-icon"
                      />
                      <span class="card-title">Metas en curso</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold"
                        >{{ dashboardData.metasEncurso || 0 }}</b
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="status-card-4"
                  (mouseenter)="hoverCard = 'cumplimiento'"
                  (mouseleave)="hoverCard = ''"
                >
                  <div
                    class="content-card-4"
                    [ngClass]="{'hovered': hoverCard === 'cumplimiento'}"
                  >
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-2.svg"
                        class="card-icon"
                      />
                      <span class="card-title">% Cumplimiento</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold"
                        >{{ dashboardData.cumplimiento | number:'1.0-0' }}%</b
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="status-card-4"
                  (mouseenter)="hoverCard = 'total'"
                  (mouseleave)="hoverCard = ''"
                >
                  <div
                    class="content-card-4"
                    [ngClass]="{'hovered': hoverCard === 'total'}"
                  >
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-4.svg"
                        class="card-icon"
                      />
                      <span class="card-title">Total alcanzado</span>
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold"
                        >{{ dashboardData.totalAlcanzado | montoInteligente }}</b
                      >
                    </div>
                  </div>
                </div>

                <div
                  class="status-card-4"
                  (mouseenter)="hoverCard = 'ganadas'"
                  (mouseleave)="hoverCard = ''"
                >
                  <div
                    class="content-card-4"
                    [ngClass]="{'hovered': hoverCard === 'ganadas'}"
                  >
                    <div class="card-header">
                      <img
                        src="assets/svg/report-icon-3.svg"
                        class="card-icon"
                      />
                      <span class="card-title"
                        >Total oportunidades ganadas</span
                      >
                    </div>
                    <div class="card-body">
                      <b class="card-amount-bold"
                        >{{ dashboardData.cumplimiento | number:'1.0-0' }}</b
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="header-stats mt-3"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div>
            <span>{{ metasFiltradas.length }} elementos | Se actualizó hace 2 minutos</span>
            <span *ngIf="hasActiveFilters()" class="filter-badge" style="margin-left: 10px;">
              Filtros aplicados
              <button (click)="clearFilters()" class="clear-filters-btn">×</button>
            </span>
          </div>

          <div
            *ngIf="usuariosSeleccionados > 0"
            style="display: flex; align-items: center; gap: 10px"
          >
            <span class="selection-count" style="font-weight: 500">
              {{ usuariosSeleccionados }} Metas seleccionadas
            </span>

            <div class="actions-container" style="position: relative">
              <div (click)="toggleActionsDropdown()" class="actions-dropdown">
                <span>Seleccionar acción</span>
                <span [class.rotated]="showActionsDropdown"></span>
                <img
                  src="assets/svg/arrow-down-black.svg"
                  class="sort-icon"
                  style="width: 12px; height: 12px"
                />
              </div>

              <div *ngIf="showActionsDropdown" class="dropdown-content">
                <a *ngIf="permissionService.hasPermission('Metas','Eliminar')" (click)="ejecutarAccion('eliminar')" class="dropdown-item"
                  >Eliminar</a
                >
                <a (click)="ejecutarAccion('desactivar')" class="dropdown-item"
                  >Desactivar</a
                >
                <a (click)="ejecutarAccion('activar')" class="dropdown-item"
                  >Activar</a
                >
              </div>
            </div>
          </div>
        </div>
        
        <div class="content-area mt-5">
          <div *ngIf="errorMessage" class="error-message">{{errorMessage}}</div>
          <div *ngIf="!isLoading && metas.length > 0">
            <div class="d-grid search-bar-container" style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  width: 100%;
                  gap: 16px;
                ">
              <div class="npt-table-search-bar d-grid" style="flex: 1; min-width: 0">
                <div><img src="assets/svg/search.svg" alt="" /></div>
                <input
                  type="text"
                  class="npt-nav-search"
                  placeholder="Buscar en esta lista..."
                  [(ngModel)]="searchTerm"
                  (input)="onSearchChange()"
                  style="flex: 1; min-width: 0; width: 100%"
                />
              </div>
              <div style="display: flex; gap: 12px; flex-shrink: 0">
                <button
                  class="search-btn"
                  (click)="refrescarMetas()"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    white-space: nowrap;
                  "
                >
                  <img src="assets/svg/reload-icon.svg" alt="Actualizar" />
                  <span>Actualizar</span>
                </button>
                <button
                  class="search-btn"
                  (click)="openFilterModal()"
                  style="
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    white-space: nowrap;
                  "
                >
                  <img src="assets/svg/filtrar-icon.svg" alt="Filtrar" />
                  <span>Filtrar</span>
                </button>
              </div>
            </div>

            <div class="opp-table-container mh-50">
              <table>
                <thead>
                  <tr>
                    <th style="width: 40px"></th>
                    <th class="checkbox-column">
                      <img src="assets/svg/checkline-icon.svg" />
                    </th>
                    <th 
                      (click)="sortByColumn('usuario.nombre')"
                      [class.sorted]="sortColumn === 'usuario.nombre'"
                      class="sortable-header"
                    >
                      <div style="display: inline-flex; align-items: center; gap: 6px;">
                        <img src="assets/svg/marked-icon.svg" alt="Marcado" style="width: 16px; height: 16px" />
                        <span>Asignado a</span>
                        <span *ngIf="sortColumn === 'usuario.nombre'" class="sort-indicator">
                          {{ sortDirection === 'asc' ? '↑' : '↓' }}
                        </span>
                      </div>
                    </th>
                    <th 
                      (click)="sortByColumn('descripcion')"
                      [class.sorted]="sortColumn === 'descripcion'"
                      class="sortable-header"
                    >
                      Descripción
                      <span *ngIf="sortColumn === 'descripcion'" class="sort-indicator">
                        {{ sortDirection === 'asc' ? '↑' : '↓' }}
                      </span>
                    </th>
                    <th 
                      (click)="sortByColumn('valor_objetivo')"
                      [class.sorted]="sortColumn === 'valor_objetivo'"
                      class="sortable-header"
                    >
                      Valor objetivo
                      <span *ngIf="sortColumn === 'valor_objetivo'" class="sort-indicator">
                        {{ sortDirection === 'asc' ? '↑' : '↓' }}
                      </span>
                    </th>
                    <th 
                      (click)="sortByColumn('fecha_inicio')"
                      [class.sorted]="sortColumn === 'fecha_inicio'"
                      class="sortable-header"
                    >
                      Fecha de inicio
                      <span *ngIf="sortColumn === 'fecha_inicio'" class="sort-indicator">
                        {{ sortDirection === 'asc' ? '↑' : '↓' }}
                      </span>
                    </th>
                    <th 
                      (click)="sortByColumn('fecha_fin')"
                      [class.sorted]="sortColumn === 'fecha_fin'"
                      class="sortable-header"
                    >
                      Fecha de cierre
                      <span *ngIf="sortColumn === 'fecha_fin'" class="sort-indicator">
                        {{ sortDirection === 'asc' ? '↑' : '↓' }}
                      </span>
                    </th>
                    <th 
                      (click)="sortByColumn('estado')"
                      [class.sorted]="sortColumn === 'estado'"
                      class="sortable-header"
                    >
                      Estado
                      <span *ngIf="sortColumn === 'estado'" class="sort-indicator">
                        {{ sortDirection === 'asc' ? '↑' : '↓' }}
                      </span>
                    </th>
                    <th 
                      (click)="sortByColumn('progreso_actual')"
                      [class.sorted]="sortColumn === 'progreso_actual'"
                      class="sortable-header"
                    >
                      Progreso
                      <span *ngIf="sortColumn === 'progreso_actual'" class="sort-indicator">
                        {{ sortDirection === 'asc' ? '↑' : '↓' }}
                      </span>
                    </th>
                    <th 
                      (click)="sortByColumn('fecha_actualizacion')"
                      [class.sorted]="sortColumn === 'fecha_actualizacion'"
                      class="sortable-header"
                    >
                      Ultima modificación
                      <span *ngIf="sortColumn === 'fecha_actualizacion'" class="sort-indicator">
                        {{ sortDirection === 'asc' ? '↑' : '↓' }}
                      </span>
                    </th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let meta of metasFiltradas; let i = index">
                    
                    <td class="counter-cell">{{ i + 1 }}.</td>
                    <td class="checkbox-column">
                      <input
                        type="checkbox"
                        (change)="onCheckboxChange($event , meta.meta_id)"
                      />
                    </td>
                    <td>
                      <div
                        style="
                          display: inline-flex;
                          align-items: center;
                          gap: 6px;
                          white-space: nowrap;
                        "
                      >
                        <img
                          [src]="meta?.marcado === 0 ? 'assets/svg/unmarked-icon.svg' : 'assets/svg/marked-icon.svg'"
                          alt="Favorito"
                          style="width: 16px; height: 16px; cursor: pointer"
                          (click)="updateMarca(meta.meta_id)"
                        />
                        <span class="color-org"
                          >{{ meta.usuario?.nombre }} {{ meta.usuario?.apellido
                          }}</span
                        >
                      </div>
                    </td>
                    <td>{{meta.descripcion}}</td>
                    <td>CLP {{meta.valor_objetivo}}</td>
                    <td>{{meta.fecha_inicio | date:'dd/MM/yyyy'}}</td>
                    <td
                      class="fecha-cierre"
                      (mouseenter)="selectedMetaIndex =i"
                      (mouseleave)="selectedMetaIndex = null"
                    >
                            <span 
                            [ngClass]="{
                              'fecha-vencida': getMetaStatus(meta) === 'vencida', 
                              'fecha-proxima': getMetaStatus(meta) === 'proxima',
                              'fecha-sin-avances': getMetaStatus(meta) === 'sin-avances',
                              'fecha-baja-actividad': getMetaStatus(meta) === 'baja-actividad',
                              'fecha-estancada': getMetaStatus(meta) === 'estancada',
                              'fecha-superada': getMetaStatus(meta) === 'superada',
                              'fecha-antes': getMetaStatus(meta) === 'antes'
                            }"
                            [ngSwitch]="getMetaStatus(meta)">
                            
                            {{ meta.fecha_fin | date:'dd/MM/yyyy' }}

                            <img *ngSwitchCase="'superada'" src="assets/svg/diana-icon.svg" alt="Meta superada" class="icono-fecha" />
                            <img *ngSwitchCase="'antes'" src="assets/svg/diana-icon.svg" alt="Alcanzada antes de tiempo" class="icono-fecha" />
                            <img *ngSwitchCase="'proxima'" src="assets/svg/time-icon.svg" alt="Próxima a vencer" class="icono-fecha" />
                            <img *ngSwitchCase="'sin-avances'" src="assets/svg/time-icon.svg" alt="Próxima al cierre sin avances" class="icono-fecha" />
                            <img *ngSwitchCase="'baja-actividad'" src="assets/svg/warning-icon.svg" alt="Aviso por baja actividad" class="icono-fecha" />
                            <img *ngSwitchCase="'estancada'" src="assets/svg/warning-icon.svg" alt="Meta estancada" class="icono-fecha" />
                            <img *ngSwitchCase="'vencida'" src="assets/svg/warning-icon.svg" alt="Meta atrasada" class="icono-fecha" />
                          </span>
                      <div class="popover-card" *ngIf="selectedMetaIndex === i && getPopoverClass(meta) !== ''">
                        <div
                          class="popover-header"
                          [ngClass]="getPopoverClass(meta)"
                        >
                          <span>{{ getPopoverTitle(meta) }}</span>
                          <button
                            class="close-btn"
                            (click)="closePopover($event)"
                          >
                            ×
                          </button>
                        </div>
                        <div class="popover-body">
                          <p>
                            La meta <b>"{{ meta.descripcion }}"</b> {{
                            getPopoverMessage(meta) }}
                          </p>
                          <small
                            >Progreso actual: {{ meta.progreso_actual * 100 |
                            number:'1.0-0' }}% cumplido.</small
                          >
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      <span
                        [ngClass]="{
                                'status-completado': meta.estado === 'Completado',
                                'status-incompleto': meta.estado === 'Incompleto',
                                'status-sininiciar': meta.estado === 'Sin iniciar',
                                'status-encurso': meta.estado === 'En curso'
                               }"
                      >
                        {{ meta.estado }}
                      </span>
                    </td>
                    <td class="progreso-cell">
                      <div class="progress-bar">
                        <div
                          class="progress-fill"
                          [style.width.%]="meta.progreso_actual * 100"
                        ></div>
                      </div>
                      <span class="progress-text"
                        >{{ meta.progreso_actual * 100 | number:'1.0-0'
                        }}%</span
                      >
                    </td>
                    <td>{{meta.fecha_actualizacion | date:'dd/MM/yyyy'}}</td>
                    <td
                      style="
                        padding: 8px;
                        border-top: 1px solid #ddd;
                        display: flex;
                        gap: 8px;
                      "
                    >
                      <span
                      *ngIf="permissionService.hasPermission('Metas','Editar')"
                        style="text-decoration: underline"
                        class="link-modificar"
                        (click)="openMdlUpdateGoal(meta)"
                      >
                        <img
                          src="assets/svg/orange-pen-icon.svg"
                          style="width: 14px; height: 14px"
                          
                        />

                        Modificar
                      </span>

                      <span
                      *ngIf="permissionService.hasPermission('Metas','Eliminar')"
                        style="text-decoration: underline"
                        class="link-eliminar"
                        (click)="openmdldeleteGoal(meta.meta_id)"
                        
                      >
                        <img
                          src="assets/svg/orange-trash-can-icon.svg"
                          style="width: 14px; height: 14px"
                        />
                        Eliminar
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            *ngIf="!isLoading && metas.length === 0 && !errorMessage"
            class="empty-state"
          >
            <div class="empty-content">
              <div class="empty-image">
                <img
                  src="assets/img/listaprospecto.png"
                  alt="Lista de prospectos vacía"
                />
              </div>
              <h2>Sin Metas por ahora</h2>
              <p>
                Todavía no tienes metas registradas. Puedes comenzar agregando
                una nueva.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>